// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_title__-WeHq {
    align-items: center;
    color: #18316e;
    display: flex;
    flex: 1 1;
    font-family: "Abhaya Libre";
    font-size: 2rem;
    font-weight: 600;
    gap: 15px;
  }

  .styles_action__sendMsg__g90QM {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-block: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/ChatAssincrono/styles.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,SAAO;IACP,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":[".title {\n    align-items: center;\n    color: #18316e;\n    display: flex;\n    flex: 1;\n    font-family: \"Abhaya Libre\";\n    font-size: 2rem;\n    font-weight: 600;\n    gap: 15px;\n  }\n\n  .action__sendMsg {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    padding-block: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `styles_title__-WeHq`,
	"action__sendMsg": `styles_action__sendMsg__g90QM`
};
export default ___CSS_LOADER_EXPORT___;
